import { Injectable } from '@angular/core';

import { LocalStorageService } from '../../../../pages/user/services/local-storage.service';
import { MenuItemChild } from '../models/menu-item-child.model';

@Injectable()
export class MenuUtilsService {
  constructor(private localStorage: LocalStorageService) {}

  userHavePermission(_permission): boolean {
    const permission = this.localStorage
      .getObject('user')
      .permissoes.find((p) => p === _permission);
    return permission ? true : false;
  }

  calculateSubmenuHeight(_children: Array<MenuItemChild>): string {
    // 4px = margin-top do .children-container.
    let pxValue: number = 4;

    _children.forEach((child) => {
      if (child.visible) {
        // Altura real de cada item: 12+12 de padding + ~19px de texto no <a>
        // + 2px de margin-bottom do <li>. Valores menores cortam o fundo
        // do item selecionado (overflow: hidden no container).
        pxValue += 45;
      }
    });

    return `${pxValue}px`;
  }
}
